module.exports = __webpack_public_path__ + "img/categoryFruits.bb99f865.svg";